import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=c625de7a&scoped=true&"
import script from "./DashboardIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIndex.vue?vue&type=style&index=0&id=c625de7a&prod&lang=css&"
import style1 from "./DashboardIndex.vue?vue&type=style&index=1&id=c625de7a&prod&scoped=true&lang=css&"
import style2 from "./DashboardIndex.vue?vue&type=style&index=2&id=c625de7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625de7a",
  null
  
)

export default component.exports